import cx from 'classnames';
import React from 'react';
import SignUpForm from '../../Views/Signup/SignUpForm';

const View = (props) => {
  const { data, className, style } = props;
  return (
    <div className={cx('block', 'signup', className)} style={style}>
      <SignUpForm source_input={data.source_input} />
    </div>
  );
};

export default View;
